<p-toast
    position="center"
    key="custom"
    (onClose)="userService.onRejectUserActivity()"
    [baseZIndex]="9999"
>
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center">
                <i
                    class="pi pi-exclamation-triangle"
                    style="font-size: 3rem"
                ></i>
                <h3>{{ message.summary }}</h3>
                <p>{{ message.detail }}</p>
            </div>
            <div class="p-grid p-text-center">
                <div>
                    <button
                        type="button"
                        pButton
                        (click)="userService.onRejectUserActivity()"
                        label="Continue"
                        class="p-button-success"
                    ></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <main-nav></main-nav>
            <breadcrumbs></breadcrumbs>
            <router-outlet class="sm-pad-none"></router-outlet>
            <app-image-viewer></app-image-viewer>
            <app-async-modal></app-async-modal>
            <app-context-menu></app-context-menu>
            <footer-bar></footer-bar>
        </div>
    </div>
</div>
<div class="loading-overlay spinner" *ngIf="globals.isSpinnerVisible()">
    <div class="loader"></div>
    <p *ngIf="globals.spinnerMessage" [innerHtml]="globals.spinnerMessage"></p>
</div>
<progress-measure></progress-measure>
